export default {"src":"/_next/static/image/public/assets/icons/minus.5c070970d636c3e989088ef7b65b023f.svg","height":20,"width":20};